import { Link, useSearchParams } from "react-router-dom";

const HUMAN: Record<string, string> = {
  missing_token: "The sign-in link was incomplete.",
  missing_tokens: "We didn't get any tokens back from the server.",
  invalid_or_expired_link: "That sign-in link is no longer valid (it may have been used already or expired).",
  oauth_state_mismatch: "OAuth state check failed. Try signing in again.",
  oauth_exchange_failed: "We couldn't complete the OAuth handshake.",
  missing_email: "Your provider didn't share an email address with us.",
};

export function AuthError() {
  const [params] = useSearchParams();
  const reason = params.get("reason") ?? "unknown";
  const message = HUMAN[reason] ?? "Something went wrong during sign-in.";
  return (
    <main className="mx-auto flex min-h-full max-w-md flex-col justify-center gap-4 p-8 text-center">
      <h1 className="text-2xl font-semibold tracking-tight">Sign-in failed</h1>
      <p className="text-sm text-slate-600 dark:text-slate-300">{message}</p>
      <p className="text-xs text-slate-500 dark:text-slate-400">
        Code: <code className="font-mono">{reason}</code>
      </p>
      <Link
        to="/signin"
        className="inline-block self-center rounded-md bg-slate-900 px-3 py-2 text-sm font-medium text-white hover:bg-slate-800 dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-slate-200"
      >
        Back to sign in
      </Link>
    </main>
  );
}
